/* All free solid fontawesome icons -> https://fontawesome.com/icons?d=gallery&s=brands&m=free */

import {
  faBootstrap,
  faFacebook,
  faFacebookF,
  faGithub,
  faGoogle,
  faHtml5,
  faInstagram,
  faTwitter,
  faGooglePlay,
  faYoutube,
  faYoutubeSquare
} from '@fortawesome/free-brands-svg-icons';

export const fontAwesomeBrandsIcons = {
  faBootstrap,
  faFacebook,
  faFacebookF,
  faGithub,
  faGoogle,
  faHtml5,
  faInstagram,
  faTwitter,
  faGooglePlay,
  faYoutubeSquare,
  faYoutube
};
